export default __webpack_public_path__ + "static/media/hungryMonsterImageTwo.a4e7fc30.png";